import {withTranslation} from "react-i18next";
import {Link} from "react-router-dom";
import React, {PureComponent} from "react";
import Connect from "react-redux/es/connect/connect";

class RecoveryPasswordContainer extends PureComponent {

    render() {
        const {t} = this.props;
        return (
            <div className="login-container-screen-actions-container-recovery">
                <div className="login-container-screen-actions-container-recovery-form">
                <br/>
                <h4>Esqueceu a senha?</h4><br/>
                  <h5>É Coordenador Escolar?</h5>
                  <p>Solicite a recuperação da senha através do <a target="_blank" href="https://www.acorianooriental.pt/registo#recover">Açoriano Oriental</a>.</p>
                  <br/>
                  <h5>É uma turma?</h5>
                  <p>Peça ao seu Coordenador Escolar para alterar a senha da turma na área de gestão de Turmas.</p>
                </div>
                <div className="login-container-screen-actions-container-login-recovery-action">
                    <Link to="/login">{t('Go back')}</Link>
                </div>
            </div>
        );
    }
}

const mapStateToProps = store => ({
});

export default (Connect(mapStateToProps, {})(withTranslation("translations")(RecoveryPasswordContainer)));
